import { api } from "../App";
import { GET_APPLICANT_QUESTION_SET, GET_APPLICANT_QUESTION_SET_BY_ID, GET_APPLICANT_QUESTION_MODAL, GET_APPLICANT_QUESTION_MODAL_ADD } from "./types";
import { createNotification } from "../components/Notifications/Notifications";

export const getApplicantQuestionSet = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/applicant_question_set`);
    dispatch({ type: GET_APPLICANT_QUESTION_SET, payload: data });
  } catch (error) {
    createNotification('error', error.response?.data?.error || 'Ошибка');
  }
};
export const getApplicantQuestionSetById = (id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/applicant_question_set/${id}`);
    dispatch({ type: GET_APPLICANT_QUESTION_SET_BY_ID, payload: data });
  } catch (error) {
    createNotification('error', error.response?.data?.error || 'Ошибка');
  }
};
// получить вопросы которые можно добавить к варианту с id_set для параллели level
export const getQuestionsModalAdd = (id, level) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/applicant_question_set/${id}/question/${level}`);
    dispatch({ type: GET_APPLICANT_QUESTION_MODAL_ADD, payload: data });
  } catch (error) {
    createNotification('error', error.response?.data?.error || 'Ошибка');
  }
};
export const getQuestionsModal = (id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/applicant_question_set/${id}/question`);
    dispatch({ type: GET_APPLICANT_QUESTION_MODAL, payload: data });
  } catch (error) {
    createNotification('error', error.response?.data?.error || 'Ошибка');
  }
};

export const createVariant = (data) => async (dispatch, getState) => {
  try {
    const { data: result } = await api.post(`/applicant_question_set`, data);
    createNotification('success', 'Успешно');
    await dispatch(getApplicantQuestionSetById(result.id));
    await dispatch(getQuestionsModalAdd(result.id, result.level));
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось создать запись';
    createNotification('error', errorMessage);
  }
};

export const updateVariant = (data, closeModal) => async (dispatch, getState) => {
  try {
    await api.post(`/applicant_question_set/${data.id}/question`, data);
    createNotification('success', 'Успешно');
    // await dispatch(getQuestionsModal(data.id));
    await dispatch(getApplicantQuestionSetById(data.id));
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось изменить запись';
    createNotification('error', errorMessage);
  }
};


export const deleteVariant = (id) => async (dispatch, getState) => {
  try {
    await api.delete(`/applicant_question_set/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getApplicantQuestionSet());
  } catch (error) {
    createNotification('error', error.response?.data?.error || 'Ошибка');
  }
};
export const deleteVariantQuestion = (id_variant, id_question) => async (dispatch, getState) => {
  try {
    await api.delete(`/applicant_question_set/${id_variant}/question/${id_question}`);
    createNotification('success', 'Успешно');
    await dispatch(getApplicantQuestionSetById(id_variant));
  } catch (error) {
    createNotification('error', error.response?.data?.error || 'Ошибка');
  }
};